/**
 * Chat Socket.IO path. Must match backend CHAT_SOCKET_IO_PATH (default `/api/chat.socket.io`).
 */
export const CHAT_SOCKET_PATH =
  (typeof process !== 'undefined' && process.env.REACT_APP_CHAT_SOCKET_IO_PATH) ||
  '/api/chat.socket.io';
